var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-container flex flex-col w-full px-8"},[_c('Header1',{attrs:{"label":"Gutscheine scannen"}}),(!_vm.QR_CODE)?_c('VoucherScanner',{key:`s-${_vm.sIndex}`,on:{"onSetVoucher":_vm.onSetVoucher}}):_vm._e(),(_vm.QR_CODE)?_c('VoucherRedemption',{on:{"onSetVoucher":_vm.onSetVoucher}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }